import { compact, flattenDeep, get, orderBy } from 'lodash';

// constants
import { layerTypes } from 'constants/advanced';
import { cropIds } from 'constants/crops';

// selectors
import { getProductYearFromSeasonCode } from 'scripts/selectors';

// util
import { sortSelectOptionsByLabel } from 'util/formatters/selectFormatter';

const _getCombinedAvailableSeasons = (layersOfTypes) => {
  let seasons = [];
  layersOfTypes.forEach(layers => {
    layers.forEach(layer => {
      const season = getProductYearFromSeasonCode(layer.season);
      if (!seasons.includes(season)) { seasons.push(season); }
    });
  });
  return seasons.sort().reverse();
};

export const formatHistoryRowsForAvailableData = ({
  cciLayers, yieldLayers, harvestHistory, excludedLayers, canViewYieldData
}) => {
  let formattedRows = flattenDeep([cciLayers,yieldLayers]).map(layer => {
    const season = get(layer, 'season');
    const isYieldLayer = (/\:/).test(season);
    const isIncluded = !excludedLayers.find(excluded => get(excluded, 'season') === season);

    if (isYieldLayer) {
      return {
        layerType:layerTypes.YIELD,
        season,
        crop:layer.crop,
        date: layer.date,
        averageYield: canViewYieldData ? layer.averageYield : null,
        isIncluded
      };
    } else {
      const selectedCropId = harvestHistory[season] ? harvestHistory[season].cropId : null;
      const date = harvestHistory[season] && harvestHistory[season].date;
      return {
        layerType:layerTypes.CCI,
        date,
        season,
        selectedCropId,
        isIncluded
      };
    }
  });
  return orderBy(formattedRows, ['season'],['desc']);
};

export const selectHarvestHistoryCropsAndDateFromCci = (cciLayers, harvestHistory) => {
  cciLayers.forEach(cciLayer => {
    const seasonYear = getProductYearFromSeasonCode(cciLayer.season);
    if (!harvestHistory[seasonYear]) { // Don't override a user selection.
      harvestHistory[seasonYear] = {
        ...harvestHistory[seasonYear],
        date: cciLayer.date
      };
      if (cciLayer.crop) {
        harvestHistory[seasonYear] = {
          ...harvestHistory[seasonYear],
          cropId: cciLayer.crop.id
        };
      }
    }
  });
};

export const formatSelectCropListOptions = (cropList) => {
  // Put in array matching format expected by select component. Also, get rid of the duplicate
  // entries that index on name.
  const cropArray = compact(Object.keys(cropList).map(cropId =>
    isNaN(cropId) ? null : ({ id:cropId, value:cropList[cropId].name })
  ));

  // Sort options array, putting some known popular options at the top.
  const initialOptionValues = [
    String(cropIds.CORN), String(cropIds.SOYBEAN), String(cropIds.WHEAT_HARD_WHITE_WINTER), String(cropIds.OTHER)
  ];
  const sortedCropArray = sortSelectOptionsByLabel({options:cropArray, initialOptionValues,
    ignoreMissingOptionValues:true}); // Ignoring possible error here, because impact would be small.

  return sortedCropArray;
};

export const unitTestPrivate = {
  _getCombinedAvailableSeasons
};


/**
 * Format history rows by season
 * @param {Array} historyRows
 * @return {Object}
 */
export const formatHistoryRowsBySeason = (historyRows) => {
  const formatedRows = historyRows.reduce((result, row) => {
    const season = row.season.split(':')[0];
    if (!result[season]) {
      result[season] = [];
    }
    result[season].push(row);
    return result;
  }, {});
  return formatedRows;
};
